import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SocialWidget from "../Widget/SocialWidget";
// import Newsletter from '../Widget/Newsletter';
import "./header.scss";
import ContactInfoWidget from "../Widget/ContactInfoWidget";
import Div from "../Div";
import DropDown from "./DropDown";

export default function Header({ variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    });
  }, []);

  return (
    <>
      <header
        className={`cs-site_header cs-style1 text-uppercase ${
          variant ? variant : ""
        } cs-sticky_header ${isSticky ? "cs-sticky_header_active" : ""}`}
      >
        <Div className="cs-main_header">
          <Div className="container">
            <Div className="cs-main_header_in">
              <Div className="cs-main_header_left">
                <Link className="cs-site_branding" to="/">
                  <img src="/images/LagosGold_sm.png" alt="Logo" />
                </Link>
              </Div>
              <Div className="cs-main_header_center">
                <Div className="cs-nav cs-primary_font cs-medium">
                  <ul
                    className="cs-nav_list"
                    style={{ display: `${mobileToggle ? "block" : "none"}` }}
                  >
                    {/* Removed the drop down since the logo link returns to the homepage. Reduce redundancy = increase performance */}
                    <li>
                      <Link to="/about" onClick={() => setMobileToggle(false)}>
                        About
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/services"
                        onClick={() => setMobileToggle(false)}
                      >
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pricing"
                        onClick={() => setMobileToggle(false)}
                      >
                        Pricing
                      </Link>
                    </li>
                    <li>
                      <Link to="/team" onClick={() => setMobileToggle(false)}>
                        Team
                      </Link>
                    </li>
                    <li>
                      {" "}
                      {/* className="menu-item-has-children"*/}
                      <Link
                        to="/litepaper"
                        onClick={() => setMobileToggle(false)}
                      >
                        Litepaper
                      </Link>
                    </li>
                    <li>
                      {" "}
                      {/* className="menu-item-has-children"*/}
                      <Link
                        to="/portfolio"
                        onClick={() => setMobileToggle(false)}
                      >
                        Portfolio
                      </Link>
                    </li>
                    <li>
                      {" "}
                      {/* className="menu-item-has-children"*/}
                      <a
                        href="https://www.mehchant.com/"
                        target="_blank"
                        rel="noreferrer"
                        className="cs-center"
                        onClick={() => setMobileToggle(false)}
                      >
                        Shop
                      </a>
                    </li>
                    <li className="menu-item-has-children">
                      <Link onClick={() => setMobileToggle(false)}>
                        Directory
                      </Link>
                      <DropDown>
                        <ul>
                          <li>
                            <Link
                              to="/contact"
                              onClick={() => setMobileToggle(false)}
                            >
                              Contact Us
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/team"
                              onClick={() => setMobileToggle(false)}
                            >
                              Team
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/blog"
                              onClick={() => setMobileToggle(false)}
                            >
                              Blogs
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/faq"
                              onClick={() => setMobileToggle(false)}
                            >
                              FAQ
                            </Link>
                          </li>
                        </ul>
                      </DropDown>
                    </li>
                  </ul>
                  <span
                    className={
                      mobileToggle
                        ? "cs-munu_toggle cs-toggle_active"
                        : "cs-munu_toggle"
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </Div>
              </Div>
              <Div className="cs-main_header_right">
                <Div className="cs-toolbox">
                  <span
                    className="cs-icon_btn"
                    onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
                  >
                    <span className="cs-icon_btn_in">
                      <span />
                      <span />
                      <span />
                      <span />
                    </span>
                  </span>
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </header>

      <Div
        className={
          sideHeaderToggle ? "cs-side_header active" : "cs-side_header"
        }
      >
        <button
          className="cs-close"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div
          className="cs-side_header_overlay"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div className="cs-side_header_in">
          <Div className="cs-side_header_shape" />
          <Link className="cs-site_branding" to="/">
            <img src="/images/LagosGold_sm.png" alt="Logo" />
          </Link>
          <Div className="cs-side_header_box">
            <h2 className="cs-side_header_heading">
              Learn about our projects
              <br /> Contact Us Today.
            </h2>
          </Div>
          <Div className="cs-side_header_box">
            <ContactInfoWidget title="Contact Us" withIcon />
          </Div>
          <Div className="cs-side_header_box">
            <SocialWidget />
          </Div>
        </Div>
      </Div>
    </>
  );
}
